import { i18n } from "../../i18n";
import { FlagIcon } from "../FlagIcon";
import { Icon } from "../Icon";
import { FlagCountry } from "../../../types";
import { sendClickEvent } from "../../analytics/google-analytics";

declare let window: ProductPage;

export const retailerInfoModalAriaData = {
  ariaLabel: "Store information",
  ariaDescribedby:
    "Store information including seller details and shipping information",
};

const defaultBanner =
  "/marketplace/images/storefronts/default-storefront-1024.webp";

const getBadge = (badgeImageUrl: string | undefined) => {
  if (badgeImageUrl) {
    return (
      <div class="Badge mt-n48 mx-auto">
        <img src={badgeImageUrl} alt="Store logo" />
      </div>
    );
  }

  return (
    <div class="Badge Badge__Default Badge__Small mt-n48 mx-auto">
      <Icon name="storefront" fill="#fff" width={24} height={24} />
    </div>
  );
};

export const RetailerInfoModalContent = () => {
  const {
    name,
    addressLine,
    companyNumber,
    vrn,
    premiumSeller,
    inRegionShipping,
    daysToDispatch,
    shippingFromCountryName,
    shippingFromCountryCode,
    shopUrl,
    bannerImageUrl,
    badgeImageUrl,
  } = window.retailerInformation;

  const banner = bannerImageUrl ?? defaultBanner;

  return (
    <div className="tw:mt-4">
      <section id="store-information-aria-description" class="sr-only">
        {i18n("modal.store-information-description", name)}
      </section>
      <div class="position-relative">
        <img src={banner} alt="Store banner" class="dialog-banner" />
        <div class="Hero__Fade"></div>
      </div>
      {getBadge(badgeImageUrl)}
      <div class="p-16">
        <h2 class="text-center font-weight-light">{name}</h2>
        {premiumSeller && (
          <div class="d-flex align-items-center mb-16">
            <Icon name="verified" fill="#00a9ff" className="mr-8" />
            <strong>{i18n("retailer.premium-seller")}</strong>
          </div>
        )}
        {addressLine && (
          <div class="d-flex align-items-center mb-16">
            <Icon name="location" className="mr-8" />
            <p class="m-0">
              <strong>{i18n("product.retailer.address")}: </strong>
              {addressLine}
            </p>
          </div>
        )}
        {companyNumber && (
          <div class="d-flex align-items-center mb-16">
            <Icon name="tag" className="mr-8" />
            <p class="m-0">
              <strong>{i18n("product.retailer.company-number")}: </strong>
              {companyNumber}
            </p>
          </div>
        )}
        {vrn && (
          <div class="d-flex align-items-center mb-16">
            <Icon name="find-in-page" className="mr-8" />
            <p class="m-0">
              <strong>{i18n("product.retailer.vrn")}: </strong>
              {vrn}
            </p>
          </div>
        )}
        {daysToDispatch != null && (
          <div class="d-flex align-items-center mb-16">
            <Icon name="acute" className="mr-8" />
            <p class="m-0">
              <strong>
                {daysToDispatch > -1 && daysToDispatch <= 1
                  ? i18n("product.dispatched.within.twentyfourhours")
                  : i18n(
                      "product.dispatched.within",
                      daysToDispatch.toString()
                    )}
              </strong>
            </p>
          </div>
        )}
        {inRegionShipping && (
          <div class="d-flex align-items-center">
            <Icon name="location" className="mr-8" />
            <p class="m-0 d-flex">
              <strong class="mr-8">
                {i18n("product.shipping-returns.shipping-origin-label")}{" "}
              </strong>
              {shippingFromCountryCode && (
                <FlagIcon
                  country={shippingFromCountryCode as FlagCountry}
                  className="mr-8"
                  aria-hidden="true"
                />
              )}
              {shippingFromCountryName}
            </p>
          </div>
        )}
      </div>
      {shopUrl && (
        <footer>
          <a
            href={shopUrl}
            class="button"
            onClick={() =>
              sendClickEvent("retailer_modal_visit_shop", "Visit Shop")
            }
          >
            {i18n("product.retailer.visit", "")}
          </a>
        </footer>
      )}
    </div>
  );
};
